// This file is AUTOGENERATED, do not edit it manually!!!

export const inlineEdit = {
    ActivityChildrenActualHours_Text: 'Saisies de temps pour toutes les sous-activités :',
    ActivityChildrenEstimatedHours_Text: 'Heures estimées pour toutes les sous-activités :',
    ActivityOwnBudget_Text: 'Budget pour l\'activité :',
    ActivityOwnEstimatedHours_Text: 'Heures estimées pour l\'activité :',
    ActivitySubactivitiesBudget_Text: 'Budget pour toutes les sous-activités :',
    ActualCompletion_Text: 'Fin effective',
    ActualHours_Total_Text: 'Heures réelles, total :',
    AddTimeEntry_Text: 'Ajouter une entrée de temps',
    AddUser_Text: 'Inviter utilisateur',
    Apply: 'Appliquer',
    Assignees_Text: 'Personnes assignées',
    BudgetedCost_Text: 'Coût Budgétisé :',
    BudgetPadding_Text: 'Contingence :',
    BudgetTotal_Text: 'Budget, total :',
    Cancel: 'Annuler',
    Close: 'Fermer',
    Combobox_Add: 'Ajouter ',
    Combobox_KeepTyping: 'Continuez votre saisie...',
    Combobox_MultipleSelectDefault: 'Sélectionnez quelques options',
    Combobox_NoResults: 'Aucun résultat',
    Combobox_NoResultsMatch: 'Aucun résultat ne correspond ',
    Cost_Text: 'Coût:',
    CreateAndSelect: 'Créer et sélectionner',
    CustomerLabel: 'Client',
    Duration_Text: 'Durée',
    EditProjectMembers_Title: 'Membres du Projet',
    EditTaskAssignees_Title: 'Personnes assignées',
    End_Text: 'Fin',
    EndDate_Text: 'Date de fin',
    EstimatedHours_Text: 'Heures estimées:',
    EstimatedHours_Total_Text: 'Heures estimées, total:',
    Hours_Short_Text: 'h',
    HoursLeftLabel: 'Heures restantes',
    InternalCost_Text: 'Coût Interne :',
    NonProjectMembers_Text: 'Membres n\'appartenant pas au projet',
    Overloaded_Text: 'Surchargé',
    OwnActualHours_Text: 'Journal d\'heures pour l\'activité:',
    PlannedExpenses_Text: 'Dépenses Prévues :',
    PortfolioLabel: 'Portefeuille',
    Progress: 'Progression',
    ProgressCalculatedBySubActivities: 'Basé sur le progrès des sous-activités',
    ProjectChildrenActualHours_Text: 'Saisies de temps pour les activités :',
    ProjectChildrenEstimatedHours_Text: 'Heures estimées pour toutes les activités:',
    ProjectMembers_Text: 'Membres du Projet',
    ProjectOwnBudget_Text: 'Budget pour le projet:',
    ProjectOwnEstimatedHours_Text: 'Heures estimées pour le projet:',
    ProjectSubactivitiesBudget_Text: 'Budget pour toutes les activités:',
    Start_Text: 'Démarrer',
    StartDate_Text: 'Date de Début',
    Teams_Text: 'Équipes',
    Tooltip_Dependent_Template: '{0} est liée à une activité dépendante et ne peut pas être modifiée',
    Tooltip_HasChildren_Template: '{0} est calculé(e) en fonction des sous-activités et ne peut pas être modifié(e)',
    Tooltip_ItemCompleted: 'La date ne peut être modifiée parce qu\'elle est liée à une activité ou un projet fermé.',
    Untitled: 'Sans titre',
    Validation_ActComplDateRange: 'La date de fin effective ne tombe pas dans la plage attendue.',
    Validation_DateMandatory: 'La date est un champ requis.',
    Validation_DurationMandatory: 'La durée est un champ obligatoire.',
    Validation_EndDateRange: 'La Date de fin ne tombe pas dans la plage attendue.',
    Validation_FieldMandatory: 'Ce champ est obligatoire.',
    Validation_FromDateRange: 'La Date de début ne tombe pas dans la plage attendue.',
    Validation_Interger: 'La valeur doit être un nombre entier.',
    Validation_InvalidDate: 'La date doit être au format \'{0}\'.',
    Validation_NumberRange: 'La valeur doit être comprise entre {0} et {1}.',
    Validation_Range: 'La valeur ne correspond pas à la fourchette attendue',
    Validation_StartDateRange: 'La Date de début ne tombe pas dans la plage attendue.',
    Validation_ToDateRange: 'La Date de fin ne tombe pas dans la plage attendue.',
    Validation_WeekendOrVacation: 'La Valeur ne doit pas tomber sur un week-end ou vacances.',
    Warning_UnassigneFromAllTasksInProject: 'Les membres retirés seront également retirés de toutes les activités de ce projet.',
};
